module.exports = __webpack_public_path__ + "images/dropdown-arrow.svg";